import script from "./BottomNovaSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomNovaSheet.vue?vue&type=script&setup=true&lang=ts"

import "./BottomNovaSheet.vue?vue&type=style&index=0&id=57120482&lang=less"

const __exports__ = script;

export default __exports__